export default {
  station_activity: {
    name: '用户访问日志',
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      ev_charging_station: '充电站',
      user: '用户',
      action: '操作',
      ip: 'IP地址',
      created_at: '创建时间',
      action_result: '结果',
      description: '描述',
      station_source_type: '站类型',
      api_params: 'API参数',
      operation: '操作',
      app_client: '客户端',
      next_station_activity: '下一启动日志'
    },
    prop: {
      ev_charging_station: '充电站(充电桩)'
    },
    actions: {
      start_charge: '启动充电',
      stop_charge: '停止充电',
      visit: '访问',
      parking_fee_relief: '停车减免',
      control_lock: '控制地锁'
    },
    action_results: {
      success: '成功',
      fail: '失败'
    },
    app_clients: {
      miniprogram: '小程序',
      ios: 'iOS',
      android: '安卓',
      other: '其它'
    },
    btn: {
      view_params: '查看参数',
      view_ip: '查询IP',
      statistics: '访问统计',
      view_activity: '查看日志',
      view_order: '查看订单'
    },
    titles: {
      statistics: '访问统计',
      start_charge_fail: '启动失败原因',
      start_charge_user: '启动用户'
    },
    statistics_prop: {
      station: '充电站',
      city: '城市',
      created_at: '访问时间',
      visit_count: '访问次数 (次)',
      visit_users_count: '访问人数 (人)',
      start_charge_count: '启动充电次数 (次)',
      start_charge_fail_count: '启动失败次数 (次)',
      start_charge_users_count: '充电用户数 (人)',
      user: '用户'
    },
    labels: {
      time_interval: '秒后'
    }
  }
}
